import React from "react";
import useResponsive from "../../../../core/hooks/useResponsive";
import variables from "../../../../themes/base/styles/variables";
import { TwoColumn, TwoRow } from "../../../../core/layouts";

export const LegendMenuBarStyles = {
  legendMenuBar: {
    width: variables.operationAuditLegendMenubarWidth,
    height: variables.fullHeight,
    border: variables.border,
    marginTop: variables.operationAuditLegendMenubarMarginTop,
    padding: variables.paddingSmallest2,
  },
  container: {
    display: variables.dFlex,
    justifyContent: variables.spaceBetween,
  },
  labelStyle: {
    gap: variables.gapXS4,
    alignItems: variables.alignCenter,
  },
  labelBox: {
    display: variables.dFlex,
    fontWeight: variables.fontWeightNormal,
    fontSize: variables.fontSizeSmall,
    padding: variables.paddingSmallest,
    gap: variables.gapXS4,
    color: variables.charade,
    justifyContent: variables.spaceBetween,
  },
  colorBox: {
    width: variables.iconWidth2,
    height: variables.iconHeight2,
    borderRadius: variables.borderRadius2,
  },
  labelValue: {
    fontSize: variables.fontSizeSmallest,
    color: variables.charade,
  },
  tabletMenuBarStyle: {
    height: variables.operationAuditLegendMenubarTabletHeight,
    flexDirection: variables.flexDirection1,
  },
  tabletContainer: {
    flexWrap: variables.flexWrap,
  },
  tabletLabelBox: {
    fontSize: variables.fontSizeSmall,
    padding: variables.paddingSmallest2,
  },
  tabletLabelHeading: {
    fontSize: variables.fontSizeSmall,
  },
  tabletLabelValue: {
    fontSize: variables.fontSizeSmall,
    padding: variables.paddingSmallest2,
  },
  mobileMenuBarStyle: {
    width: variables.fullWidth,
    height: variables.fullHeight,
    display: variables.dFlex,
    border: variables.border,
    flexDirection: variables.flexDirection2,
    justifyContent: variables.spaceBetween,
  },
  mobileContainer: {
    flexDirection: variables.flexDirection2,
  },
  mobileLabelBox: {
    fontSize: variables.fontSizeSmallest,
    padding: variables.paddingSmallest3,
    justifyContent: variables.spaceBetween,
    alignItems: variables.alignCenter,
    gap: variables.gapXS1,
  },
  mobileLabelValue: {
    fontSize: variables.fontSizeSmall,
    padding: variables.paddingSmallest3,
  },
};

const LegendMenubar = ({ data, boxColor2, checked }) => {
  const responsive = useResponsive();
  const convertToPercent = (number) => parseFloat(number).toFixed(2);
  return data?.map((box) => {
    return (
      <TwoRow
        style={
          responsive.isMd
            ? LegendMenuBarStyles.legendMenuBar
            : LegendMenuBarStyles.mobileMenuBarStyle
        }
        topSectionStyle={LegendMenuBarStyles.container}
        topSection={
          <TwoColumn
            style={
              responsive.isLg
                ? LegendMenuBarStyles.labelBox
                : LegendMenuBarStyles.mobileLabelBox
            }
            leftSection={
              <TwoColumn
                style={LegendMenuBarStyles.labelStyle}
                leftSection={
                  <div
                    style={{
                      ...LegendMenuBarStyles.colorBox,
                      backgroundColor: box?.fill,
                    }}
                  />
                }
                rightSectionStyle={
                  responsive.isLg ? LegendMenuBarStyles.tabletLabelHeading : {}
                }
                rightSection={responsive.isMd ? box?.name :`${box?.name} :`}
              />
            }
            rightSectionStyle={
              responsive.isLg
                ? LegendMenuBarStyles.labelValue
                : responsive.isMd
                ? LegendMenuBarStyles.tabletLabelValue
                : LegendMenuBarStyles.mobileLabelValue
            }
            rightSection={
              !checked
                ? (box?.completedAudit)
                : convertToPercent(box?.completedAudit)
            }
          />
        }
        bottomSectionStyle={LegendMenuBarStyles.container}
        bottomSection={
          <TwoColumn
            style={
              responsive.isLg
                ? LegendMenuBarStyles.labelBox
                : LegendMenuBarStyles.mobileLabelBox
            }
            leftSection={
              <TwoColumn
                style={LegendMenuBarStyles.labelStyle}
                leftSection={
                  <div
                    style={{
                      ...LegendMenuBarStyles.colorBox,
                      backgroundColor: boxColor2,
                    }}
                  />
                }
                rightSection={responsive.isMd ? box?.displayName : `${box?.displayName} :`}
              />
            }
            rightSectionStyle={
              responsive.isLg
                ? LegendMenuBarStyles.labelValue
                : responsive.isMd
                ? LegendMenuBarStyles.tabletLabelValue
                : LegendMenuBarStyles.mobileLabelValue
            }
            rightSection={
              !checked
                ? (box?.totalAudit)
                : convertToPercent(box?.totalAudit)
            }
          />
        }
      />
    );
  });
};

export default LegendMenubar;
